import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import FormControlLabel from '@mui/material/FormControlLabel';
import Link from '@mui/material/Link';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Card from 'components/Card';
import CardItem from 'components/CardItem';
import Button from 'components/Button';
import IOSSwitch from 'components/Switch';
import moment from 'moment';
import api from 'services/api';

export default function CardRastreador(props) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(!props.rastreador.deleted_at);
  const readableTextColor = '#627182';

  async function toggleStatus(rastreador) {
    await api.put(`trackers/${rastreador.id}`, {
      deleted_at: !active ? null : moment(),
    });
  }

  function handleClickOpen(group) {
    setOpen(true);
  }

  function handleClose() {
    setOpen(false);
  }

  async function confirmOption(group) {
    setOpen(false);
    setActive(!active);
    toggleStatus(group);
  }

  function details(trackerId, trackerName) {
    navigate(`/rastreadores/${trackerId}/modelos/${trackerName}`);
  }

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" style={{ color: readableTextColor }}>
          Habilitar rastreador
        </DialogTitle>
        <DialogContent>
          <DialogContentText style={{ color: readableTextColor }}>
            Deseja habilitar o rastreador?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            outline={1}
            onClick={handleClose}
            color="primary"
            style={{ color: '#494950', borderColor: '#494950' }}
          >
            Cancelar
          </Button>
          <Button
            onClick={() => confirmOption(props.rastreador)}
            color="primary"
            autoFocus
          >
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>

      <Grid item xs={12} style={{ width: '100%', maxWidth: '720px' }}>
        <Card
          style={{
            marginTop: '10px',
          }}
        >
          <div style={{ padding: '14px 16px' }}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '16px',
              }}
            >
              <CardItem className="nameClients">{props.rastreador.name}</CardItem>
              <FormControlLabel
                style={{
                  color: '#76838F',
                  marginRight: 0,
                }}
                control={
                  <IOSSwitch
                    checked={active}
                    value={active}
                    onClick={() => handleClickOpen(props.rastreador)}
                  />
                }
                labelPlacement="start"
                label={active ? 'ativo' : 'inativo'}
              />
            </div>
            <hr style={{ margin: '12px 0' }} />
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: '12px' }}>
              <Link
                style={{
                  fontWeight: 'bold',
                  textTransform: 'uppercase',
                  cursor: 'pointer',
                  display: 'inline-block',
                }}
                onClick={() => props.handleOpened(props.rastreador)}
              >
                Ver / Editar
              </Link>
              <Link
                style={{
                  fontWeight: 'bold',
                  textTransform: 'uppercase',
                  cursor: 'pointer',
                  display: 'inline-block',
                }}
                onClick={() => details(props.rastreador.id, props.rastreador.name)}
              >
                Modelos
              </Link>
            </div>
          </div>
        </Card>
      </Grid>
    </>
  );
}
